// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_3nikN","FooterTop":"FooterTop_NPx-r"};